import { SearchTerm } from "./SearchTerm";

const FirstInLastOutReportSearch: SearchTerm[] = [
    {
        heading: "First Name",
        accessor: "firstName",
        searchOnName: "master.mstFirstname",
        translationKey: "firstName"
    },
    {
        heading: "Second Name",
        accessor: "middleName",
        searchOnName: "master.mstMiddlename",
        translationKey: "secondName"
    },
    {
        heading: "Last Name",
        accessor: "lastName",
        searchOnName: "master.mstLastname",
        translationKey: "lastName"
    },
    {
        heading: "Display Name",
        accessor: "displayName",
        searchOnName: "master.mstDisplayname",
        translationKey: "displayName"
    },
    {
        heading: "Unique Identifier",
        accessor: "mstIdnumber",
        searchOnName: "master.mstIdnumber",
        translationKey: "uniqueIdentifier"
    },
    {
        heading: "Suffix",
        accessor: "suffix",
        searchOnName: "master.mstSuffix",
        translationKey: "suffix"
    },
    {
        heading: "Title",
        accessor: "title",
        searchOnName: "master.mstTitle",
        translationKey: "title"
    },
    {
        heading: "Category",
        accessor: "categoryType",
        searchOnName: "master.profile.trnName",
        translationKey: "category"
    },
    {
        heading: "Company",
        accessor: "compName",
        searchOnName: "master.company.compName",
        translationKey: "company"
    },
    {
        heading: "Department",
        accessor: "deptName",
        searchOnName: "master.department.deptName",
        translationKey: "department"
    },
]

export default FirstInLastOutReportSearch;
